import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_PRODUCT_FILTERS } from "../../components/controls/CommonFunctions";

const initialState = {
  productFilters: DEFAULT_PRODUCT_FILTERS ||{} ,
  salesHistoryFilters: {},
  inventoryHistoryFilters: {},
  deliveryFilters: {},
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setProductFilters: (state, action) => {
      state.productFilters = action.payload;
    },
    setSalesHistoryFilters: (state, action) => {
      state.salesHistoryFilters = action.payload;
    },
    setInventoryHistoryFilters: (state, action) => {
      state.inventoryHistoryFilters = action.payload;
    },
    setDeliveryFilters: (state, action) => {
      state.deliveryFilters = action.payload;
    },
    clearAllFilters: (state) => {
      state.productFilters = {};
      state.salesHistoryFilters = {};
      state.inventoryHistoryFilters = {};
      state.deliveryFilters = {};
    },
  },
});

export const {
  setProductFilters,
  setSalesHistoryFilters,
  setInventoryHistoryFilters,
  setDeliveryFilters,
  clearAllFilters,
} = filterSlice.actions;

// Selectors
export const selectProductFilters = (state) => state.filter.productFilters;
export const selectSalesHistoryFilters = (state) => state.filter.salesHistoryFilters;
export const selectInventoryHistoryFilters = (state) => state.filter.inventoryHistoryFilters;
export const selectDeliveryFilters = (state) => state.filter.deliveryFilters;

export default filterSlice.reducer;
